import {
  DOCUMENT_PROGRESS__EXPIRY_DATE_CHANGE_REQUEST,
  DOCUMENT_PROGRESS__REQUEST_CANCEL_REQUEST,
  DOCUMENT_PROGRESS__SIGNING_REMIND_REQUEST,
} from '@app/store/actionTypes';
import { DocumentProgressAction } from '@app/store/documentProgress/actions';

type DocumentProgressCurrentProcessingDocumentIdState = string | null;

const initialState: DocumentProgressCurrentProcessingDocumentIdState = null;

/**
 * 현재 단건으로 서명 재요청, 서명 유효일 변경, 서명 요청 취소 처리 중인 documentId
 */
export default function reducer(
  state: DocumentProgressCurrentProcessingDocumentIdState = initialState,
  action: DocumentProgressAction
) {
  switch (action.type) {
    case DOCUMENT_PROGRESS__EXPIRY_DATE_CHANGE_REQUEST:
    case DOCUMENT_PROGRESS__REQUEST_CANCEL_REQUEST:
    case DOCUMENT_PROGRESS__SIGNING_REMIND_REQUEST:
      return action.payload.documentId;
    default:
      return state;
  }
}
